"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var http_1 = tslib_1.__importDefault(require("http"));

var https_1 = tslib_1.__importDefault(require("https"));

var isomorphic_fetch_1 = tslib_1.__importDefault(require("isomorphic-fetch"));

var legacy_provider_adapter_1 = require("./legacy-provider-adapter");

var HttpProvider = /*#__PURE__*/function (_legacy_provider_adap) {
  _inherits(HttpProvider, _legacy_provider_adap);

  function HttpProvider(host) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, HttpProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(HttpProvider).call(this, new LegacyHttpProvider(host, options)));
  }

  return HttpProvider;
}(legacy_provider_adapter_1.LegacyProviderAdapter);

exports.HttpProvider = HttpProvider;

var LegacyHttpProvider = /*#__PURE__*/function () {
  function LegacyHttpProvider(host) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LegacyHttpProvider);

    this.host = host;
    this.options = options;
    this.host = host || 'http://localhost:8545';

    if (options.keepAlive) {
      this.options.agent = /^https/.test(this.host) ? new https_1.default.Agent({
        keepAlive: true
      }) : new http_1.default.Agent({
        keepAlive: true
      });
    }
  }

  _createClass(LegacyHttpProvider, [{
    key: "send",
    value: function send(payload, callback) {
      isomorphic_fetch_1.default(this.host, _objectSpread({}, this.options, {
        method: 'POST',
        credentials: 'include',
        headers: _objectSpread({}, this.options.headers, {
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload)
      })).then(function (response) {
        return response.json();
      }).then(function (json) {
        return callback(undefined, json);
      }).catch(callback);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }]);

  return LegacyHttpProvider;
}();